export const types = { 
    REFRESH_PURCHASE:'REFRESH_PURCHASE',
    FETCH_ENCODED_PRODUCT: "FETCH_ENCODED_PRODUCT",
    FETCH_PURCHASE_PRODUCT: 'FETCH_PURCHASE_PRODUCT',
    FETCH_LIVE_PRODUCT: 'FETCH_LIVE_PRODUCT'
};